import { useState } from "react";
import { FileDown } from "lucide-react";
import { useData } from "@/context/DataContext";
import { download } from "@/lib/accounting";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CompareTab } from "@/components/control/CompareTab";
import { BudgetTab } from "@/components/control/BudgetTab";
import { ProductivityTab } from "@/components/control/ProductivityTab";

const THIS_YEAR = new Date().getFullYear();
const REPORT_MONTHS = Array.from({ length: 13 }, (_, i) => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - i); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; });
const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("it-IT", { month: "long", year: "numeric" });

const ReportDownload = () => {
  const { companyId } = useData();
  const [month, setMonth] = useState(REPORT_MONTHS[1]);
  return (
    <div className="flex items-center gap-2">
      <select className="h-10 border bg-white px-2 text-sm capitalize" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="report-month">{REPORT_MONTHS.map((m) => <option key={m} value={m}>{monthLabel(m)}</option>)}</select>
      <Button variant="outline" onClick={() => download("/control/monthly-report", { month, company_id: companyId || undefined }, `report-direzione-${month}.pdf`)} data-testid="report-download-button"><FileDown className="mr-1 h-4 w-4" />Scarica report</Button>
    </div>
  );
};

export default function ManagementControl() {
  const [year, setYear] = useState(THIS_YEAR);
  const [tab, setTab] = useState("compare");
  return (
    <div data-testid="control-page">
      <PageHeader eyebrow="Budget, consuntivo e produttività" title="Controllo di gestione">
        <div className="flex flex-wrap items-center gap-3">
          <ReportDownload />
          {tab !== "productivity" && <select className="h-10 border bg-white px-3 text-sm" value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="control-year">
            {[THIS_YEAR - 2, THIS_YEAR - 1, THIS_YEAR, THIS_YEAR + 1].map((y) => <option key={y} value={y}>{y}</option>)}
          </select>}
        </div>
      </PageHeader>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4 flex-wrap">
          <TabsTrigger value="compare" data-testid="control-tab-compare">Budget e consuntivo</TabsTrigger>
          <TabsTrigger value="budget" data-testid="control-tab-budget">Inserisci budget</TabsTrigger>
          <TabsTrigger value="productivity" data-testid="control-tab-productivity">Produttività tecnici</TabsTrigger>
        </TabsList>
        <TabsContent value="compare"><CompareTab year={year} /></TabsContent>
        <TabsContent value="budget"><BudgetTab year={year} /></TabsContent>
        <TabsContent value="productivity"><ProductivityTab /></TabsContent>
      </Tabs>
    </div>
  );
}
